import axios, { AxiosInstance } from 'axios';

export class AccessTokenValidatorClient {
  public static api: AxiosInstance = axios.create({
    baseURL: process.env.ACCESS_TOKEN_VALIDATOR_BASE_URL,
  });
}
